/**
 * Vue de la liste patients sous la présentation E (ADR 0068) : « Tableau »
 * (défaut) ou « Guichet » (liste + aperçu de la fiche). Mémorisée dans le
 * navigateur. État d'interface seulement : jamais de jeton ici (INV-5).
 */
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export type PatientsListView = "table" | "desk";

interface PatientsListViewState {
  view: PatientsListView;
  setView: (view: PatientsListView) => void;
}

export const usePatientsListViewStore = create<PatientsListViewState>()(
  persist(
    (set) => ({
      view: "table",
      setView: (view) => set({ view }),
    }),
    {
      name: "mada.patients.list-view",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
